import React from 'react';

export const FormField = ({ label, children }) => (
    <div className="form-control">
        <label className="label">
            <span className="label-text">{label}</span>
        </label>
        {children}
    </div>
);

export const InlineFormField = ({ label, children }) => (
    <div className="form-control flex items-center">
        <label className="label flex items-center">
            <span className="label-text mr-2">{label}</span>
            {children}
        </label>
    </div>
);

